import {
    AfterViewChecked,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { faCoffee } from '@fortawesome/free-solid-svg-icons'
import { DatePickerComponent } from '@progress/kendo-angular-dateinputs'
import {
    DropDownFilterSettings,
    DropDownListComponent,
    MultiSelectComponent,
} from '@progress/kendo-angular-dropdowns'
import * as CryptoJS from 'crypto-js'
import { NgxUiLoaderModule, NgxUiLoaderService } from 'ngx-ui-loader'
import { EMPTY, Subscription, delay, map, merge, of } from 'rxjs'
import { distinctUntilChanged, startWith, switchMap, tap } from 'rxjs/operators'
import { environment } from '../../../../environments/environment'

import { CommonModule, DatePipe, NgClass, NgFor, NgIf } from '@angular/common'
import { NgIcon, provideIcons } from '@ng-icons/core'
import { heroChatBubbleLeftRight, heroCurrencyDollar, heroExclamationCircle } from '@ng-icons/heroicons/outline'
import { ButtonComponent, ButtonModule, KENDO_BUTTON } from '@progress/kendo-angular-buttons'
import { KENDO_DIALOG, WindowComponent } from '@progress/kendo-angular-dialog'
import { KENDO_GRID } from '@progress/kendo-angular-grid'
import { KENDO_INPUTS, KENDO_NUMERICTEXTBOX, KENDO_TEXTAREA, NumericTextBoxComponent, RadioButtonDirective, TextBoxDirective } from '@progress/kendo-angular-inputs'
import { KENDO_LABELS } from '@progress/kendo-angular-label'
import { IndividualConfig, ToastrService } from 'ngx-toastr'
import { ClientServices } from '../../../@theme/services/clients.service'
import { RepServices } from '../../../@theme/services/replist.service'
import { TypesServices } from '../../../@theme/services/typeslist.service'
import { MiddlemanService } from '../../../auth/services/Middleman.service'
import { MiddleService } from '../../Transactions/atoms/middle.service'
import { CommaExpr } from '@angular/compiler'
import { PHONE_MASK, toPhoneDigits } from '../../../@theme/pipes/phone.pipe'
interface Item {
  text: string
  value: number
}
@Component({
    selector: 'gd-accounttransaction',
    styleUrls: ['./accounttransaction.component.css'],
    templateUrl: './accounttransaction.component.html',
    imports: [
      CommonModule,
        NgxUiLoaderModule,
        FormsModule,
        ReactiveFormsModule,
        NgIf,
        WindowComponent,
        NgFor,
        NgClass,
        DropDownListComponent,
        DatePickerComponent,
        TextBoxDirective,
        RadioButtonDirective,
        ButtonModule,
        KENDO_NUMERICTEXTBOX,
        KENDO_LABELS,
        KENDO_TEXTAREA,
        KENDO_INPUTS,
        ButtonComponent,
        KENDO_DIALOG,
        DatePipe,
        KENDO_BUTTON, KENDO_GRID,
        NgIcon
    ],
    providers: [
      provideIcons({ heroCurrencyDollar, heroExclamationCircle, heroChatBubbleLeftRight })
    ],
    standalone: true,
    encapsulation: ViewEncapsulation.None,
})
export class AccountTransactionComponent implements OnInit, AfterViewChecked {
  public isSameAddressControl: UntypedFormControl = new UntypedFormControl(
    false,
  )
  @Input() fields: any
  @Input() repCodestring: string
  @Input() productTypestring: string
  @ViewChild('multiselect', { static: false })
  public multiselect: MultiSelectComponent
  @ViewChild('inputControlDropdownlist', { static: true })
  public inputControlDropdownlist: DropDownListComponent
  @Output() openEvent: EventEmitter<any> = new EventEmitter()
  @ViewChild('myname', { static: false }) input: ElementRef
  @ViewChild('maskvalue', { static: false }) maskvalue: ElementRef
  @ViewChild('annualIncFrom', { static: false }) annualIncFrom: NumericTextBoxComponent
  // True while the Date of Account Form datepicker (incl. its popup) holds focus.
  private dateFormActive = false
  private dateFormPicker: DatePickerComponent | null = null
  public editaccountlist: any[] = []
  public roleSelect: boolean
  public getBlotterId: number
  private getClientId: number
  private getRepsId: number
  private paramValueinsert: number
  public submitdisable: boolean
  private getRepId: number
  private roleString: string
  private str: string
  private cit: string
  private sta: string
  private zip: string
  private getRepcodeId: number
  public Msecondary = false
  public maskValidation = false
  public copyfields = false
  public focusedDateAccountform: Date = new Date()
  public focusedDateAccountformsecond: Date = new Date()
  public focusedDatemaildate: Date = new Date()
  public focusedDOBDate: Date = new Date('1/5/2005')
  public calculatedDob: string
  public ageAtTransaction: string
  public focusedDOBDatesecond: Date = new Date()
  public calculatedDobSecond: string
  // ######################
  public labelClient: string
  public labelRepCode: string
  public labelClientName: string
  public labelProductType: string
  public labelTransaction: string
  public labelSplitRepName: string
  public labelSplitRepNameonoff = true
  public labelStatus: string
  // The alert as it arrived on the transaction, before the user touched it.
  private approvedAlertWasOn = false
  public labelDOB: string
  public selectstate: string
  // ######################
  public queryupdate: boolean
  public buttonType: string
  public formatOptions: any = {
    style: 'currency',
    currency: 'USD',
    currencyDisplay: 'name',
    prefix: '',
  }
  private values: Date = new Date()
  private valuesrecieved: Date = new Date()
  private valuesmaildate: Date = new Date()
  private valuesDOB: Date = new Date()
  private valuessecondary: Date = new Date()
  private valuessecondarymature: Date = new Date()
  public value = ''
  private subscription: Subscription
  private rolesplit: string
  private rolesplitfirst: string
  private splitvalue: string
  public advisorrole: boolean
  public headtitlePopup: any = []
  public opened = false
  public taxList: any = []
  public autoCorrect = true
  public min: Date = new Date(1917, 0, 1)
  public max: Date = new Date(2010, 11, 31)
  public age: number
  public name = ''
  public style1: boolean
  public HeaderInfo: string
  public FirstNamecompany: string
  public displaysecondaryck: boolean
  public displayInfo: boolean
  public secondaryForm: boolean
  public secondaryheader: string
  public secondarymainheader: string
  public showtaxinfo: boolean
  public annualbool: boolean
  public annualboolvalue: boolean
  public networthbool: boolean
  public networthboolvalue: boolean
  public Liquidbool: boolean
  public Liquidboolvalue: boolean
  public riskbool: boolean
  public riskvalue: boolean
  public investbool: boolean
  public investvalue: boolean
  public liquiddropbool: boolean
  public liquiddropvalue: boolean
  public timehorizonbool: boolean
  public timehorizonboolvalue: boolean
  public advisebool: boolean
  public adviseboolvalue: boolean
  public style0: boolean
  public style00: boolean
  public style2: boolean
  public style3: boolean
  public style4: boolean
  public style5: boolean
  public style6: boolean
  public fname: boolean
  public fnamevalue: boolean
  public lname: boolean
  public lnamevalue: boolean
  public dobbool: boolean
  public dobboolvalue: boolean
  public addrboolvalue: boolean
  private boolValue = false
  public addrbool: boolean
  public ctybool: boolean
  public ctyboolvalue: boolean
  public statebool: boolean
  public statevalue: boolean
  public zipbool: boolean
  public zipvalue: boolean
  public signa: boolean
  public signahasvalue: boolean
  public dtebool: boolean
  public dtevalue: boolean
  public displaytext: string
  public investmin = 1950
  public investmax = 2040
  private producttypeId: number
  private transactiontypeId: number
  public SeletedupdatedList: Array<Item> = [
    { text: 'Rep Processing Paperwork', value: -2 },
    { text: 'Processing Paperwork', value: 0 },
    { text: 'Submitted for Review', value: 1 },
  ]
  public SeletedStatus: Array<string> = ['On File', 'Submitted', 'Missing']
  public SeletedMailToList: Array<string> = [
    'Overnight',
    'Regular Mail',
    'Fax',
    'Other',
  ]
  faCoffee = faCoffee
  public getrepcodeid: string;
  public mask = '###-##-####'
  public secondarymask = '###-##-####'
  public mobileMask = PHONE_MASK
  public zipcodelist: Array<string> = ['#####-####', '#####']
  public zipcodestring: string
  public zipcodelist2: Array<string> = ['#####-####', '#####']
  public zipcodestring2: string
  private encPassword: string
  public newloginForm: UntypedFormGroup
  public events: string[] = []
  public listItems: Array<any> = []
  public clientlisting: Array<any> = []
  public listClientTypes: Array<any> = []
  public listStates: Array<any> = []
  public InvestObjLists: Array<any> = []
  public InvestObjnwewLists: Array<any> = []
  public LiquidityNeedsLists: Array<any> = []
  public TimeHorizonLists: Array<any> = []
  public Taxmasklist: Array<string> = ['##-#######', '###-##-####']
  public data: Array<any>
  public masklistlisting: Array<any> = []
  public text: string
  public paramgetRepId: any
  public loader = true
  public Tr1: boolean
  public liqquidloading: boolean
  public timezoneloading: boolean
  public loaderType: boolean
  public loaderstatelist: boolean
  public investloading: boolean
  public investobjloading: boolean
  public repdata: any
  public accountname: string
  public statusList: Array<any> = []
  public selectedStatus: Array<string> = [
    'basic',
    'primary',
    'danger',
    'success',
    'info',
    'warning',
  ]
  public statusIndex0: string
  public statusIndex1: string
  public statusIndex2: string
  public showmessage0: boolean
  public showmessage1: boolean
  public showmessage2: boolean
  // Starts false so the Delete button stays hidden while the role is still
  // unknown, rather than flashing up for a rep on a cold load.
  public Rolerep: boolean = false
  public RoleAdvisor: boolean
  public isAdmin: boolean
  private rparam: any
  public hideclientreplist: boolean
  windowPosition = { top: 200, left: 50 }; // default to avoid undefined errors
  public get numValue(): number {
    return +this.value
  }

  profileForm = new UntypedFormGroup({
    AccountName: new UntypedFormControl(''),
    AccountOpen: new UntypedFormControl(true),
    Address1: new UntypedFormControl(''),
    Address2: new UntypedFormControl(''),
    AdvisorClient: new UntypedFormControl(false),
    AlertRep: new UntypedFormControl(false),
    AlertRepText: new UntypedFormControl(''),
    AlertRepTextselect: new UntypedFormControl(''),
    AnnualIncFrom: new UntypedFormControl(''),
    AnnualIncTo: new UntypedFormControl(''),
    AssociatedAccount: new UntypedFormControl(''),
    AssociatedPerson: new UntypedFormControl(''),
    cbCopyToSecondary: new UntypedFormControl(''),
    ccemails: new UntypedFormControl(''),
    ModifiedBy: new UntypedFormControl(''),
    ModifiedDate: new UntypedFormControl(''),
    City: new UntypedFormControl(''),
    ClientId: new UntypedFormControl(),
    ClientTypeId: new UntypedFormControl(),
    Comment: new UntypedFormControl(''),
    CommExp: new UntypedFormControl(''),
    CompanyName: new UntypedFormControl(''),
    CopyOfDl: new UntypedFormControl(''),
    DateOfNewAccountForm: new UntypedFormControl(''),
    DateReceivedForm: new UntypedFormControl(''),
    DOB: new UntypedFormControl(''),
    DocumentDescription: new UntypedFormControl(''),
    EmailAddress: new UntypedFormControl(''),
    EquitiesExp: new UntypedFormControl(''),
    Etfexp: new UntypedFormControl(''),
    FirstName: new UntypedFormControl(''),
    FixedAnnExp: new UntypedFormControl(''),
    FixedIncExp: new UntypedFormControl(''),
    InsExp: new UntypedFormControl(''),
    InsuranceExp: new UntypedFormControl(''),
    InvestmentTimeHorizonId: new UntypedFormControl(0),
    InvObjectiveId: new UntypedFormControl(''),
    labelStatus: new UntypedFormControl(''),
    LastName: new UntypedFormControl(''),
    LiquidityNeedsList: new UntypedFormControl(''),
    LiquidNWFrom: new UntypedFormControl(''),
    LiquidNWTo: new UntypedFormControl(''),
    MailDate: new UntypedFormControl(''),
    MailLog: new UntypedFormControl(''),
    MailTo: new UntypedFormControl(''),
    MiddleName: new UntypedFormControl(''),
    Mobile: new UntypedFormControl(''),
    MutFundsExp: new UntypedFormControl(''),
    NetWorthFrom: new UntypedFormControl(''),
    NetWorthTo: new UntypedFormControl(''),
    NewAccountForm: new UntypedFormControl(''),
    OptionsExp: new UntypedFormControl(''),
    OtherExp: new UntypedFormControl(''),
    OtherExpDesc: new UntypedFormControl(''),
    PrecMetExp: new UntypedFormControl(''),
    RealEstateExp: new UntypedFormControl(''),
    RepId: new UntypedFormControl(),
    RepSignature: new UntypedFormControl(false),
    SecondaryAddress1: new UntypedFormControl(''),
    SecondaryAddress2: new UntypedFormControl(''),
    SecondaryCity: new UntypedFormControl(''),
    SecondarycopyofDLView: new UntypedFormControl(''),
    SecondaryDOB: new UntypedFormControl(''),
    SecondaryFirstName: new UntypedFormControl(''),
    SecondaryLastName: new UntypedFormControl(''),
    SecondaryMiddleName: new UntypedFormControl(''),
    SecondaryState: new UntypedFormControl(''),
    SecondaryTaxID: new UntypedFormControl(''),
    SecondaryZipCode: new UntypedFormControl(''),
    State: new UntypedFormControl(''),
    StatusTypeID: new UntypedFormControl(),
    TaxId: new UntypedFormControl(''),
    TaxIdmaskId: new UntypedFormControl(''),
    TimeHorizonList: new UntypedFormControl(''),
    Uitexp: new UntypedFormControl(''),
    Vaexp: new UntypedFormControl(''),
    WaveFee: new UntypedFormControl(false),
    ZipCode: new UntypedFormControl(''),
    addressvalidated: new UntypedFormControl(false),
  })
  options = [
    { value: 'true', label: 'Yes' },
    { value: 'false', label: 'No' },
  ]
  public filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: 'startsWith',
  }
  public virtual: any = {
    itemHeight: 28,
  }
  public showStatusHistoryButton = false
  public showStatusHistoryDialog = false
  public stathistorylist = []

  public accountDateDisabledDates = (date: Date): boolean => {
    return Date.now() - date.getTime() < 0
  }

  public checkvalueGreater(x: number, y: number) {
    if (y === 0) {
      if (x === null) {
        this.showmessage0 = false
        return
      }
      if (x <= this.profileForm.value.AnnualIncFrom) {
        this.showmessage0 = true
      } else {
        this.showmessage0 = false
      }
    }
    if (y === 1) {
      if (x === null) {
        this.showmessage1 = false
        return
      }
      if (x <= this.profileForm.value.NetWorthFrom) {
        this.showmessage1 = true
      } else {
        this.showmessage1 = false
      }
    }
    if (y === 2) {
      if (x === null) {
        this.showmessage2 = false
        return
      }
      if (x <= this.profileForm.value.LiquidNWFrom) {
        this.showmessage2 = true
      } else {
        this.showmessage2 = false
      }
    }
  }
  public changeFilterOperator(operator: any): void {
    this.filterSettings.operator = operator
  }
  constructor(
    private ngxService: NgxUiLoaderService,
    private ur: ClientServices,
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private toastrService: ToastrService,
    private lk: ClientServices,
    private _requestserv: MiddlemanService,
    private router: Router,
    private typ: TypesServices,
    private serv: RepServices,
    private fb: UntypedFormBuilder,
    private middleService: MiddleService,
  ) {
    this.GetActiveStatesList()
    this.hideclientreplist = false
    const storageValueReturn =
      localStorage.getItem('rvarietylist') == undefined
        ? ''
        : localStorage.getItem('rvarietylist')
    this.rparam = CryptoJS.AES.decrypt(
      storageValueReturn,
      environment.securepw,
    ).toString(CryptoJS.enc.Utf8)
/*     if (this.rparam.toLowerCase() === 'rep'.toLowerCase()) {
      this.Rolerep = false
    } else {
      this.Rolerep = true
    } */
    const lowerParam = this.rparam.toLowerCase();
    this.setRolerep(this.rparam)
    this.RoleAdvisor = lowerParam === 'advisor principal' ? false : true;
    this.isAdmin = lowerParam === 'admin';
    this.queryupdate = false
    this.zipcodestring = this.zipcodelist[0]
    this.zipcodestring2 = this.zipcodelist[0]
    this.advisorrole = true
    this.encPassword = environment.decPassword
    this.showtaxinfo = false
    this.Tr1 = false
    this.HeaderInfo = 'Client Information'
    this.FirstNamecompany = 'First Name'
    this.displayInfo = false
    this.secondaryForm = false
    this.showmessage0 = false
    this.showmessage1 = false
    this.showmessage2 = false
    this.dobbool = true
    this.dobboolvalue = false
    this.style5 = true
    this.style6 = false
    this.style2 = false
    this.style00 = false
    this.style1 = true
    this.style3 = true
    this.style4 = false
    this.fnamevalue = false
    this.fname = true
    this.lnamevalue = false
    this.lname = true
    this.addrboolvalue = false
    this.addrbool = true
    this.ctyboolvalue = false
    this.ctybool = true
    this.statevalue = false
    this.statebool = true
    this.zipbool = true
    this.zipvalue = false
    this.dtevalue = false
    this.dtebool = true
    this.signa = true
    this.signahasvalue = false
    this.submitdisable = false
    this.profileForm = this.fb.group({
      AccountName: ['', Validators.required],
      AccountOpen: new UntypedFormControl(true),
      Address1: [],
      Address2: [],
    //  addressvalidated: new UntypedFormControl(false),
      AdvisorClient: [],
      AlertRep: [false],
      AlertRepText: [''],
      AlertRepTextselect: [''],
      AnnualIncFrom: [],
      AnnualIncTo: [],
      AssociatedAccount: [],
      AssociatedPerson: [],
      cbCopyToSecondary: [],
      ccemails: [''],
      ModifiedBy: [''],
      ModifiedDate: [''],
      City: [],
      ClientId: [],
      ClientNoteId: [],
      ClientTypeId: ['', Validators.required],
      Comment: [],
      CommExp: [],
      CompanyName: [],
      CopyOfDl: [],
      DateOfNewAccountForm: [],
      DateReceivedForm: [],
      DOB: ['', Validators.required],
      DocumentDescription: [''],
      EmailAddress: [
        '',
        Validators.compose([
          Validators.pattern('^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$'),
          Validators.minLength(1),
        ]),
      ],
      EquitiesExp: [],
      Etfexp: [],
      FirstName: ['', Validators.required],
      FixedAnnExp: [],
      FixedIncExp: [],
      InsExp: [],
      InsuranceExp: [],
      InvestmentProfileId: [],
      InvestmentTimeHorizonId: [],
      InvObjectiveId: [],
      LastName: [''], // , Validators.required
      lblCODFaxLink: [],
      LiquidityNeedsId: [],
      LiquidNWFrom: [],
      LiquidNWTo: [],
      MailDate: [],
      MailLog: [],
      MailTo: [''],
      MiddleName: [],
      Mobile: [''],
      MutFundsExp: [],
      NetWorthFrom: [],
      NetWorthTo: [],
      NewAccountForm: [],
      OptionsExp: [],
      OtherExp: [],
      OtherExpDesc: [],
      PrecMetExp: [],
      RealEstateExp: [],
      RepId: ['', Validators.required],
      RepSignature: [],
      SecondaryAddress1: [],
      SecondaryAddress2: [],
      SecondaryCity: [],
      SecondarycopyofDLView: [],
      SecondaryDOB: [],
      SecondaryFirstName: [],
      SecondaryLastName: [],
      SecondaryMiddleName: [],
      SecondaryState: [],
      SecondaryTaxID: [],
      SecondaryZipCode: [],
      State: [],
      StatusTypeID: [],
      TaxId: ['', Validators.required],
      TaxIdmaskId: [],
      Uitexp: [],
      Vaexp: [],
      WaveFee: [],
      ZipCode: [],
      addressvalidated: []

    })
    this.data = []
    this.statusIndex0 = this.selectedStatus[2]
    this.statusIndex1 = this.selectedStatus[2]
    this.statusIndex2 = this.selectedStatus[2]
    this.timezoneloading = true
    this.liqquidloading = true
    if (this.route.snapshot.queryParams['Cld']) {
      this.route.queryParams.subscribe((params) => {
        this.getClientId = Number(params['Cld'])
        this.EditTransactionStartMethod(this.getClientId)
        this.queryupdate = true
        this.profileForm.get('ClientId').setValue(this.getClientId)
      })
    } else {
      this.queryupdate = false
    }
    if (this.route.snapshot.queryParams['repunencrypt']) {
      this.route.queryParams.subscribe((params) => {
        this.getRepId = Number(params['repunencrypt'])
        this.labelRepCode = this.repCodestring
      })
    }
    this.ngxService.startLoader('loader-77')
  }
  ngAfterViewChecked() {
    if (this.profileForm.value.DOB) {
      this.dobboolvalue = true
      this.dobbool = false
    } else {
      this.dobbool = true
      this.dobboolvalue = false
    }
    if (this.profileForm.value.RepId) {
      this.style0 = false
      this.style00 = true
    } else {
      this.style00 = false
      this.style0 = true
    }
    if (this.profileForm.value.AccountName) {
      this.style1 = false
      this.style2 = true
    } else {
      this.style2 = false
      this.style1 = true
    }
    if (this.profileForm.value.ClientTypeId) {
      this.style5 = false
      this.style6 = true
    } else {
      this.style6 = false
      this.style5 = true
    }
    if (this.profileForm.value.TaxId) {
      this.style4 = true
      this.style3 = false
    } else {
      this.style3 = true
      this.style4 = false
    }
    if (this.profileForm.value.FirstName) {
      this.fname = false
      this.fnamevalue = true
    } else {
      this.fnamevalue = false
      this.fname = true
    }
    if (this.profileForm.value.LastName) {
      this.lname = false
      this.lnamevalue = true
    } else {
      this.lnamevalue = false
      this.lname = true
    }
    if (this.profileForm.value.Address1) {
      this.addrbool = false
      this.addrboolvalue = true
    } else {
      this.addrbool = true
      this.addrboolvalue = false
    }
    if (this.profileForm.value.City !== null) {
      this.ctybool = false
      this.ctyboolvalue = true
    } else {
      this.ctyboolvalue = false
      this.ctybool = true
    }
    if (this.profileForm.value.State !== null) {
      this.statebool = false
      this.statevalue = true
    } else {
      this.statevalue = false
      this.statebool = true
    }
    if (this.profileForm.value.ZipCode !== null) {
      if (this.profileForm.value.ZipCode.trim().length > 4) {
        this.zipbool = false
        this.zipvalue = true
      } else {
        this.zipbool = true
        this.zipvalue = false
      }
    }
    if (this.profileForm.value.DateOfNewAccountForm !== '') {
      this.dtebool = false
      this.dtevalue = true
    } else {
      this.dtevalue = false
      this.dtebool = true
    }
    if (this.profileForm.value.RepSignature !== null) {
      this.signa = false
      this.signahasvalue = true
    } else {
      this.signa = true
      this.signahasvalue = false
    }
    if (
      this.profileForm.value.AnnualIncFrom !== null &&
      this.profileForm.value.AnnualIncTo !== null
    ) {
      this.annualbool = false
      this.annualboolvalue = true
    } else {
      this.annualboolvalue = false
      this.annualbool = true
    }
    if (
      this.profileForm.value.NetWorthFrom !== null &&
      this.profileForm.value.NetWorthTo !== null
    ) {
      this.networthbool = false
      this.networthboolvalue = true
    } else {
      this.networthboolvalue = false
      this.networthbool = true
    }
    if (
      this.profileForm.value.LiquidNWFrom !== null &&
      this.profileForm.value.LiquidNWTo !== null
    ) {
      this.Liquidbool = false
      this.Liquidboolvalue = true
    } else {
      this.Liquidboolvalue = false
      this.Liquidbool = true
    }
    if (this.profileForm.value.InvestmentProfileId !== null) {
      this.riskbool = false
      this.riskvalue = true
    } else {
      this.riskvalue = false
      this.riskbool = true
    }
    if (this.profileForm.value.InvObjectiveId !== null) {
      this.investbool = false
      this.investvalue = true
    } else {
      this.investvalue = false
      this.investbool = true
    }
    if (this.profileForm.value.LiquidityNeedsId !== null) {
      this.liquiddropbool = false
      this.liquiddropvalue = true
    } else {
      this.liquiddropvalue = false
      this.liquiddropbool = true
    }
    if (this.profileForm.value.InvestmentTimeHorizonId !== null) {
      this.timehorizonbool = false
      this.timehorizonboolvalue = true
    } else {
      this.timehorizonboolvalue = false
      this.timehorizonbool = true
    }
    if (this.profileForm.value.AdvisorClient !== null) {
      this.advisebool = false
      this.adviseboolvalue = true
    } else {
      this.adviseboolvalue = false
      this.advisebool = true
    }
    this.maskValidation = false
    this.cdr.detectChanges()
  }
  // Delete is hidden for reps. The role is read from localStorage in the
  // constructor, but on a cold load rvarietylist has not been written yet (that
  // happens in the notifyObservable$ subscription further down), so this runs
  // again once the real role name arrives. An empty/unknown role leaves Rolerep
  // at its safe default of false, keeping Delete hidden.
  private setRolerep(roleName: string) {
    const role = (roleName || '').trim().toLowerCase()
    if (!role) {
      return
    }
    this.Rolerep = role !== 'rep'
  }

  ngOnInit() {
    this.setWindowPosition();
    this.loader = true
    this.route.queryParams.subscribe((params) => {
      const repunencrypt2 = params['clientId']
      const myblotterId = params['Rview']
        ? params['Rview'].toString()
        : params['RviewAccount']?.toString() ?? '0'
      const paramClientId = CryptoJS.AES.decrypt(
        repunencrypt2,
        environment.securepw,
      ).toString(CryptoJS.enc.Utf8)
      CryptoJS.AES.decrypt(params['rId'], environment.securepw).toString(
        CryptoJS.enc.Utf8,
      )
      const paramblotId = CryptoJS.AES.decrypt(
        myblotterId,
        environment.securepw,
      ).toString(CryptoJS.enc.Utf8)
      const gettransaction = CryptoJS.AES.decrypt(
        params['transaction'],
        `${environment.securepw}`,
      ).toString(CryptoJS.enc.Utf8)
      const getproducttype = CryptoJS.AES.decrypt(
        params['product'],
        `${environment.securepw}`,
      ).toString(CryptoJS.enc.Utf8)

      this.getrepcodeid = ''
      if (params['repCodeId']) {
        this.getrepcodeid = CryptoJS.AES.decrypt(
          params['repCodeId'],
          `${environment.securepw}`,
        ).toString(CryptoJS.enc.Utf8)
      } else if (params['repcode']) {
        this.getrepcodeid = params['repcode'] // Already a plain number
      }
      
      this.getRepcodeId = Number(this.getrepcodeid) || 0
      console.log('Initial repCodeId from params:', this.getRepcodeId, 'from:', this.getRepcodeId)
      this.getBlotterId = Number(paramblotId)
      this.producttypeId = Number(getproducttype)
      this.transactiontypeId = Number(gettransaction)
      if (Number(this.getBlotterId) === 0) {
        this.getAccountAddonlistnoblotterId(
          Number(params['Cld']),
          Number(params['repcode']),
          Number(gettransaction),
          Number(getproducttype),
          Number(this.getRepcodeId),
        )
      }
      if (this.getBlotterId > 0) {
        this.getAccountAddonlist(paramblotId)
      }
      if (this.route.snapshot.queryParams['Cld']) {
        this.queryupdate = true
        this.getAccountComments(this.getBlotterId)
      } else {
        this.queryupdate = false
      }
    })
    //  this.loader = false
    this.subscription = this._requestserv.notifyObservable$.subscribe((res) => {
      this.splitvalue = res.split('|')
      this.rolesplit = this.splitvalue[0]
      this.rolesplitfirst = this.splitvalue[1]
      this.roleString = this.rolesplit
      // rolesplit is the plain role name, so this is the reliable source - the
      // constructor may have run before it was available.
      this.setRolerep(this.rolesplit)
      const paramTN = 
      CryptoJS.AES.encrypt(this.rolesplit, environment.securepw).toString();
      const paramviewRoleTN = 
       CryptoJS.AES.encrypt(this.rolesplitfirst, environment.securepw).toString();
      localStorage.setItem('rvarietylist', paramTN)
      localStorage.setItem('rrolelisted', paramviewRoleTN)
      this.GetrepList()
      this.GetInvestmentProfileTypes()
      this.getAccountType()
      this.GetTimeZoneTypes()
      this.GetLiquidTypes()
      this.GetMaskList()
      const storageValue =
        localStorage.getItem('rvarietylist') == undefined
          ? ''
          : localStorage.getItem('rvarietylist')
      const paramTR = 
      CryptoJS.AES.encrypt(storageValue, environment.securepw).toString();
      const checkParamTR = decodeURI(paramTR)
      this.roleString = checkParamTR
      if (
        checkParamTR === 'ADVISOR PRINCIPAL' ||
        checkParamTR === 'ADVISOR USER' ||
        checkParamTR === 'ADMIN'
      ) {
        this.advisorrole = true
        this.isAdmin = checkParamTR === 'ADMIN'
      } else {
        this.advisorrole = false
        this.isAdmin = false
      }
    })
    const storageValueReturn =
      localStorage.getItem('rvarietylist') == undefined
        ? ''
        : localStorage.getItem('rvarietylist')
    const paramT = 
     CryptoJS.AES.encrypt(storageValueReturn, environment.securepw).toString();
    const checkParamT = decodeURI(paramT)
    this.roleString = checkParamT
    const repIdValue3 =
      localStorage.getItem('clRepid') == undefined
        ? ''
        : localStorage.getItem('clRepid')
    CryptoJS.AES.decrypt(repIdValue3, environment.securepw).toString(
      CryptoJS.enc.Utf8,
    )
    this.GetrepList()
    this.GetInvestmentProfileTypes()
    this.getAccountType()
    this.GetTimeZoneTypes()
    this.GetLiquidTypes()
    this.GetMaskList()
    this.profileForm.get('TaxIdmaskId').setValue(1)
    if (this.route.snapshot.queryParams['reid']) {
      this.route.queryParams.subscribe((params) => {
        const getclient = CryptoJS.AES.decrypt(
          params['reid'].trim(),
          environment.securepw.trim(),
        ).toString(CryptoJS.enc.Utf8)
        const checkParamTf = decodeURI(getclient)
        this.getRepsId = Number(checkParamTf)
      })
    }
    if (!this.route.snapshot.queryParams['Cld']) {
      setTimeout(
        () => this.profileForm.get('RepId').setValue(Number(this.getRepsId)),
        1000,
      )
    }
    this.pushCopyData()
    localStorage.setItem('UnsavedAlertText', '')
  }

  private getreturn() {
    this.statusIndex0 = this.selectedStatus[3]
  }
  private getreturn2() {
    this.statusIndex0 = this.selectedStatus[2]
  }
  private getreturn3() {
    this.statusIndex1 = this.selectedStatus[3]
  }
  private getreturn4() {
    this.statusIndex1 = this.selectedStatus[2]
  }
  private getreturn5() {
    this.statusIndex2 = this.selectedStatus[3]
  }
  private getreturn6() {
    this.statusIndex2 = this.selectedStatus[2]
  }
  public selectionStateChange(event: any) {
    if (event.value !== undefined) {
      this.statebool = false
      this.statevalue = true
      return
    } else {
      this.statevalue = false
      this.statebool = true
      return
    }
  }
  public selectionStateChange2(event: any) {
    if (event.value !== undefined) {
      this.statebool = false
      this.statevalue = true
      return
    } else {
      this.statevalue = false
      this.statebool = true
      return
    }
  }
  
  public selectchangevalues() {
    if (this.rparam.toLowerCase() === 'rep'.toLowerCase()) {
      if (this.profileForm.value.RepId) {
        this.ur.getaccountlistbyRepId().subscribe((response) => {
          this.clientlisting = response
          if (this.clientlisting.length > 0) {
            this.hideclientreplist = true
          }
        })
      }
    } else {
      const repId = { repId: this.profileForm.value.RepId }
      if (this.profileForm.value.RepId) {
        this.ur.getaccountlistbyRepIdselected(repId).subscribe((response) => {
          this.clientlisting = response
          if (this.clientlisting.length > 0) {
            this.hideclientreplist = true
          }
        })
      }
    }
  }
  setWindowPosition() {
    const windowWidth = 900;
    const windowHeight = 600; // Or whatever fixed/default height you use
  
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
  
    this.windowPosition = {
      top: screenHeight - windowHeight - 40, // 40px above bottom
      left: (screenWidth - windowWidth) / 2  // center horizontally
    };
  }
  public selectionChange(drop: any) {
    this.Tr1 = false
    this.FirstNamecompany = 'First Name'
    this.secondaryheader = 'Copy Trust Address to Trustee Address'
    this.HeaderInfo = 'Client Information'
    this.displayInfo = false
    this.secondaryForm = false
    this.style5 = false
    this.style6 = true
    /**
     * Selection Rep Id must exists in order to retrieve
     */
    if (this.rparam.toLowerCase() === 'rep'.toLowerCase()) {
      if (this.profileForm.value.RepId) {
        this.ur.getaccountlistbyRepId().subscribe((response) => {
          this.clientlisting = response
          if (this.clientlisting.length > 0) {
            this.hideclientreplist = true
          }
        })
      }
    } else {
      const repId = { repId: this.profileForm.value.RepId }
      if (this.profileForm.value.RepId) {
        this.ur.getaccountlistbyRepIdselected(repId).subscribe((response) => {
          this.clientlisting = response
          if (this.clientlisting.length > 0) {
            this.hideclientreplist = true
          }
        })
      }
    }
    this.profileForm.get('TaxIdmaskId').setValue(1)
    if (drop.clientTypeId === 7 || drop.clientTypeId === 8) {
      this.mask = '##-#######'
      this.profileForm.get('TaxIdmaskId').setValue(2)
    } else {
      this.mask = '###-##-####'
      this.profileForm.get('TaxIdmaskId').setValue(1)
    }
    if (drop.clientTypeId == 34) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A - INDV 401K</span>'
    }
    if (drop.clientTypeId == 1) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A. - INDV</span>'

      return
    }
    if (drop.clientTypeId == 2) {
      this.HeaderInfo = 'Primary Client Information'
      this.secondaryheader =
        'Copy Primary Client Address to Secondary Client Address'
      this.secondarymainheader = 'Secondary Client Information'
      this.Tr1 = true
      this.Msecondary = true
      this.secondaryForm = true
      this.displaysecondaryck = false
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN L. & JANE P. - JOINT</span>'

      return
    }
    if (drop.clientTypeId == 3) {
      this.HeaderInfo = 'Non-Individual Client Information'
      this.Tr1 = false
      this.mask = '##-#######'
      this.profileForm.get('TaxIdmaskId').setValue(1)
      this.displayInfo = true
      this.FirstNamecompany = 'Company Name:'
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">AMERICAN COMPANY INC - CORP</span>'

      return
    }
    if (drop.clientTypeId == 4) {
      this.HeaderInfo = 'Account Information'
      this.secondaryheader = 'Custodian Information'
      return
    }
    if (drop.clientTypeId == 5) {
      this.HeaderInfo = 'Minor Information'
      this.secondaryheader = 'Copy Minor Info Address to Custodian Address'
      this.displaysecondaryck = false
      this.Msecondary = true
      this.secondarymainheader = 'Custodian Information'
      this.Tr1 = true
      this.secondaryForm = true
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A CF JANE DOE - UTMA</span>'

      return
    }
    if (drop.clientTypeId == 6) {
      this.secondarymainheader = 'Beneficiary Information'
      this.secondaryheader = 'Copy Account Address to Beneficiary Address'
      this.secondaryForm = true
      this.HeaderInfo = 'Account Information'
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A FBO JANE DOE - 529</span>'
      return
    }
    if (drop.clientTypeId == 7) {
      this.displaysecondaryck = false
      this.displayInfo = true
      this.Msecondary = true
      this.HeaderInfo = 'Employer Information'
      this.FirstNamecompany = 'Company Name:'
      this.secondarymainheader = 'Employee Information'
      this.secondaryheader = 'Copy Account Address to Employer Address'
      this.Tr1 = true
      this.hideclientreplist = true
      this.secondaryForm = true
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">AMERICAN & ASSOCIATES 401K PLAN - 401K</span>'
      /*  if (RepList.SelectedValue.Length > 0 || Session["Role"].ToString() == "REP") {
              secondaryClient1Row.Style.Clear();
              secondaryClient2Row.Style.Clear();
            }
            SetSecondaryRequiredVariables(true); */
      return
    }
    if (drop.clientTypeId === 8) {
      this.displaysecondaryck = true
      this.HeaderInfo = 'Trust information'
      this.secondaryheader = 'Copy Trust information to Trustee information'
      this.secondarymainheader = 'Trustee information'
      this.Tr1 = true
      this.displaysecondaryck = false
      this.secondaryForm = true
      this.hideclientreplist = true
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">JOHN DOE TRUST DTD 1/14/98, JOHN DOE TTEE - TRUST</span>'
      return
    }
    if (drop.clientTypeId === 22) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings"> </span>'

      return
    }
    if (drop.clientTypeId === 23) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A. - ROTH</span>'

      return
    }
    if (drop.clientTypeId === 24) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">  </span>'

      return
    }
    if (drop.clientTypeId === 25) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A. - SEP</span>'
      return
    }
    if (drop.clientTypeId === 33) {
      this.HeaderInfo = 'Account Information'
      this.secondaryheader = ''
      this.secondarymainheader = 'Beneficiary Information'
      this.Tr1 = true
      this.secondaryForm = true
      this.displaysecondaryck = false
      this.secondaryheader = 'Beneficiary Information'
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A CF JANE DOE - ESA</span>'
      return
    }
    if (drop.clientTypeId === 34) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A - INDV 401K</span>'
      return
    }
    if (drop.clientTypeId === 34) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings"> </span>'

      return
    }
    if (drop.clientTypeId === 46) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A - 403B</span>'
      return
    }
    if (drop.clientTypeId === 52) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN - BEN ROTH IRA</span>'
      return
    }
    if (drop.clientTypeDesc !== '') {
      setTimeout(() => this.getreturn3(), 1000)
      return
    } else {
      setTimeout(() => this.getreturn4(), 1000)
      return
    }
  }
  public selectionChange2(drop: any) {
    if (drop !== null) {
      this.mask = drop.mask
    }
  }
  public showAlertRepText() {
    const alertText = localStorage.getItem('UnsavedAlertText')
    if (alertText !== null && alertText !== '') {
      this.profileForm.get('AlertRepText').setValue(alertText)
    }
  }
  public clearAlertRepText() {
    const alertText = this.profileForm.get('AlertRepText').value
    if (alertText !== null && alertText !== '') {
      localStorage.setItem('UnsavedAlertText', alertText)
    }
    //  localStorage.setItem('UnsavedAlertText', alertText)
  }
  public onFocus(combo) {
    if (!combo.isOpen) {
      combo.toggle(true)
    }

    if (combo._text !== '') {
      setTimeout(() => this.getreturn2(), 1000)
      return
    } else {
      setTimeout(() => this.getreturn(), 1000)
      return
    }
  }
  public onFocus2(combo2) {
    combo2.toggle(true)
  }
  private checkontaxIdexists(d: any) {
    this.profileForm.value.ClientTypeId
    const param = {
      TaxId: d,
      ClientTypeID: this.profileForm.value.ClientTypeId,
    }

    this.serv.CheckTxdreturnstrings(param).subscribe((result: any) => {
      this.headtitlePopup = result[0]
    })
    this.serv.CheckdatabasedOffTaxId(param).subscribe((result: any) => {
      this.taxList = result
      if (result !== null) {
        if (result.length > 0) {
          this.showtaxinfo = true
          this.showToast('warning', this.headtitlePopup)
        }
      }
    })
  }
 showToast(
    status: 'success' | 'error' | 'info' | 'warning',
    message: string,
    position: 'toast-top-right' | 'toast-bottom-right' | 'toast-top-left' | 'toast-bottom-left' = 'toast-top-right',
    destroyByClick = true
  ) {
    const config: Partial<IndividualConfig> = {
      positionClass: position,
      closeButton: destroyByClick,
      progressBar: true,
      timeOut: 3000,
    };

    switch (status) {
      case 'success':
        this.toastrService.success(message, '', config);
        break;
      case 'error':
        this.toastrService.error(message, '', config);
        break;
      case 'info':
        this.toastrService.info(message, '', config);
        break;
      case 'warning':
        this.toastrService.warning(message, '', config);
        break;
      default:
        this.toastrService.show(message, '', config);
        break;
    }
  }
  public onDropdownlistFocus() {
    if (
      this.inputControlDropdownlist != null &&
      this.inputControlDropdownlist != undefined
    ) {
      setTimeout(() => {
        if (!this.inputControlDropdownlist.isOpen) {
          this.inputControlDropdownlist.toggle(true)
        }
      }, 200)
    }
  }
  GetrepList() {
    this.loader = true
    this.serv.getreplist().subscribe((result: any) => {
      this.listItems = result
      this.listItems.map((reping) => {
        if (reping.lastName) {
          this.openEvent.emit()
        }
      })
      const filteredItems = this.listItems.find((reping) => {
        return reping.repId === this.getRepId
      })
      const stringWithQuotes =
        filteredItems?.lastName + ', ' + filteredItems?.firstName
      const stringWithoutQuotes = stringWithQuotes.replace(
        /{{(.*?)}}/g,
        (_, match) => {
          return `{{${match.replace(/"/g, '')}}}`
        },
      )
      this.labelClient = stringWithoutQuotes
      this.ngxService.stopLoader('loader-77')
      this.cdr.detectChanges()
    })
  }
  getAccountType() {
    this.loaderType = true
    this.loaderstatelist = true
    this.investloading = true
    this.investobjloading = true
    this.serv.getClienttypeList().subscribe((result: any) => {
      this.listClientTypes = result
      this.loaderType = false
    })
  }
  GetActiveStatesList() {
    this.typ.getActiveTypeStatelist().subscribe((r: any) => {
      this.listStates = r
      this.loaderstatelist = false
      this.GetInvestmentProfileTypes()
    })
  }
  GetInvestmentProfileTypes() {
    this.typ.getInvestmentTypelist().subscribe((r: any) => {
      this.InvestObjLists = r
      this.investloading = false
      this.GetInvestmentObjectTypes()
    })
  }
  GetInvestmentObjectTypes() {
    this.typ.getInvestmentObjectlist().subscribe((r: any) => {
      this.InvestObjnwewLists = r
      this.investobjloading = false
    })
  }
  GetLiquidTypes() {
    this.typ.getLiquidObjectlist().subscribe((r: any) => {
      this.LiquidityNeedsLists = r
      this.liqquidloading = false
    })
  }
  GetTimeZoneTypes() {
    this.typ.gettimeZoneObjectlist().subscribe((r: any) => {
      this.TimeHorizonLists = r
      this.timezoneloading = false
    })
  }

  public detectchange2(detect: any) {
    this.checkontaxIdexists(detect.value)
    if (detect.value !== '') {
      this.style4 = true
      this.style3 = false
      return
    } else {
      this.style3 = true
      this.style4 = false

      return
    }
  }
  GetMaskList() {
    this.typ.getMaskObjectlist().subscribe((r: any) => {
      this.masklistlisting = r
    })
  }

  Includemsg(response: any) {
    if (this.advisorrole === true) {
      if (response !== null) {
        setTimeout(() => {
          this.showToast(
            'success',
            `Please wait!, You are being redirected!`
          )
        }, 3000)
      }
    }
  }
  showNextMsg(response: any) {
    if (this.advisorrole === true) {
      if (response !== null) {
        const paramvalue = response.toString()
        const paramT = CryptoJS.AES.encrypt(paramvalue,this.encPassword).toString();

        this.router.navigate(['pages/advisors/AdvisorClients'], {
          queryParams: { ClientId: paramT },
        })
      }
      return
    }
  }
  onGetMessage() {
    this.showToast('success', `Account updated!`)
  }
  onGetMessageNext(response: any[]) {
    this.router.navigate(['/pages/dashboard'])
    return
  }

  onSubmit(buttonType: string): void {
    if (buttonType === 'Next') {
      const PauseEachLine = of(null)
      if (this.profileForm.value.RepSignature) {
        this.profileForm.value.RepSignature =
          this.profileForm.value.RepSignature.replace(/['"]+/g, '')
      }
      if (this.profileForm.value.ClientId === null) {
        this.profileForm.get('ClientId').setValue(0)
      }
      this.profileForm.get('AdvisorClient').setValue(false)
      this.submitdisable = false

      const Params = {
        clientInfo: this.profileForm.value,
        rolename: this.roleString,
        advisorflag: this.boolValue,
        repCodeId: (this.getRepcodeId),
        blotterId: this.getBlotterId,
        StatusTypeId: this.profileForm.get('StatusTypeID').value,
        DateReceived: this.profileForm.get('DateReceivedForm').value,
        DateOfNewAccountForm: this.profileForm.get('DateOfNewAccountForm')
          .value,
        CopyOfDl: this.profileForm.get('CopyOfDl').value,
        MailLog: this.profileForm.get('MailLog').value,
        MailTo: this.profileForm.get('MailTo').value,
        MailDate: this.profileForm.get('MailDate').value,
        ccemails: this.profileForm.get('ccemails').value,
        DocumentDescription: this.profileForm.get('DocumentDescription').value,
        AlertRepText: this.profileForm.get('AlertRepText').value,
        AlertRep: this.profileForm.get('AlertRep').value,
        WaveFee: this.profileForm.get('WaveFee').value,
        Comment: this.profileForm.get('Comment').value,
         ClientNoteId: this.profileForm.get('ClientNoteId').value,
        productTypeId: this.producttypeId,
        transactionTypeId: this.transactiontypeId,
      }
    //  console.log('Params', Params)
      this.typ
        .submitClientTransactionInfo(Params)
        .subscribe((response: any[]) => {
          merge(
            PauseEachLine.pipe(
              map(
                (
                  (cliList) => () =>
                    cliList
                )(this.onGetMessage()),
              ),
              delay(3000),
            ),
            PauseEachLine.pipe(
              map(
                (
                  (setprodId) => () =>
                    setprodId
                )(this.onGetMessageNext(response)),
              ),
              delay(3000),
            ),
          )
        })
    }
    if (buttonType === 'Removious') {
      this.opened = true
    }
  }
  public close(status: string): void {
    this.opened = false
  }
  continue() {
    const PauseEachLine = of(null)
    const Params = {
      blotterId: this.getBlotterId,
    }
    this.typ.DeleteTransactionsaccount(Params).subscribe((response: any[]) => {
      merge(
        PauseEachLine.pipe(
          map(
            (
              (cliList) => () =>
                cliList
            )(this.onGetMessage()),
          ),
          delay(3000),
        ),
        PauseEachLine.pipe(
          map(
            (
              (setprodId) => () =>
                setprodId
            )(this.onGetMessageNext(response)),
          ),
          delay(3000),
        ),
      )
    })
  }
  public open(): void {
    this.opened = true
  }
  public openClose(): void {
    this.showtaxinfo = false
  }
  public FilterAddAccountScreen(t: string, l: string): void {
    const paramT = CryptoJS.AES.encrypt(
      encodeURI(t).trim(),
      this.encPassword.trim(),
    ).toString()
    const paramL = CryptoJS.AES.encrypt(
      encodeURI(l).trim(),
      this.encPassword.trim(),
    ).toString()
    this.router.navigate(['pages/viewaccounts/view-accounts'], {
      queryParams: { existingTaxId: paramT, myLast: paramL },
    })
  }

  Lookuprecord() {
    // this.lk.CheckAddress(this.str, this.cit, this.sta, this.zip).subscribe()
  }
  public selectclientsecond(event: any) {
    this.EditTransactionsubForm(event['clientId'])
    //    this.getAccountComments(event['clientId'])
  } ///////////////////////////
  // selected client info
  selectclientbyClientId(c: number) {
    this.EditTransactionStartMethod(c['clientId'])
    this.getAccountComments(c['clientId'])
  }
  // Custodian Information //
  EditTransactionsubForm(clientId: number) {
    const param = { ClientId: clientId, Edit: 1 }
    this.lk.getAccountInfofromviewAccount(param).subscribe((r: any) => {
      this.profileForm.get('SecondaryFirstName').setValue(r[0].firstName)
      this.profileForm.get('SecondaryMiddleName').setValue(r[0].middleName)
      this.profileForm.get('SecondaryLastName').setValue(r[0].lastName)
      this.profileForm.get('SecondaryTaxID').setValue(r[0].taxId)
       this.profileForm.get('Mobile').setValue(toPhoneDigits(r[0].mobile))
      if (r[0].dob) {
        this.focusedDOBDatesecond = this.valuesDOB
        const strdov: Date[] = r[0].dob
        this.valuesDOB = new Date(strdov.toString())
        this.profileForm.get('SecondaryDOB').setValue(this.valuesDOB)
        this.focusedDOBDatesecond = this.valuesDOB
      }
      this.profileForm.get('SecondaryAddress1').setValue(r[0].secondaryAddress1)
      this.profileForm.get('SecondaryAddress2').setValue(r[0].secondaryAddress2)
      this.profileForm.get('SecondaryCity').setValue(r[0].secondaryCity)
      this.profileForm.get('SecondaryState').setValue(r[0].secondaryState)
      this.profileForm.get('SecondaryZipCode').setValue(r[0].secondaryZipCode)
    })
  }
  // Account Comments retrieve only
  getAccountComments(blotterId: number) {
    const param = { blotId: blotterId }
    this.lk.getBlotterAccountNotes(param).subscribe((r: any) => {
      if (r.length == 0) {
        return
      }
      console.log('test' + JSON.stringify(r))
      this.profileForm.get('Comment').setValue(r[0].comment)
      this.profileForm.get('ClientNoteId').setValue(r[0].blotterCommentId)
    })
  }
  getAccountAddonlist(blotterId: number) {
    const param = { blotterId: blotterId }
    this.loaderType = true
    // this.loader = true
    this.lk.GetAddonAdditionalAccountlist(param).subscribe((r: any) => {
      if (r.length == 0) {
        return
      }
      this.labelRepCode = r.repCode
      if (r.repCodeId) {
        this.getRepcodeId = Number(r.repCodeId)
        console.log('Set repCodeId from API (with blotterId):', this.getRepcodeId)
      } else {
        console.log('No repCodeId in API response (with blotterId). Current value:', this.getRepcodeId)
      }
      if (r.splitRepName) {
        this.labelSplitRepNameonoff = false
        this.labelSplitRepName = r.splitRepName
      }
      this.labelClientName = r.clientName
      this.labelProductType = r.producttypeDescription
      this.labelTransaction = r.transactionDescription
      this.profileForm.get('MailLog').setValue(r.mailLog)
      this.profileForm.get('MailTo').setValue(r.mailTo)
      this.profileForm.get('ccemails').setValue(r.ccemails)
      this.profileForm.get('StatusTypeID').setValue(r.getStatusId)
      this.profileForm
        .get('DocumentDescription')
        .setValue(r.documentDescription)
      this.profileForm.get('AlertRep').setValue(r.alertRep.toString())
      this.profileForm.get('AlertRepText').setValue(r.alertRepText)
      this.profileForm.get('WaveFee').setValue(r.waveFee.toString())
    //  this.profileForm.get('addressvalidated').setValue(false)
      this.labelStatus = r.getStatusDescription
      this.updateStatusList()
      this.showStatusHistoryButton = r.getStatusId !== -2
      this.profileForm.get('ModifiedBy').setValue(r.modifiedBy)
      this.profileForm.get('ModifiedDate').setValue(r.modifiedDate)
      if (r.mailDate !== undefined) {
        const str2: Date[] = r.mailDate
        this.valuesmaildate = new Date(str2.toString())
        this.profileForm.get('MailDate').setValue(this.valuesmaildate)
        this.focusedDatemaildate = this.valuesmaildate
      } else {
        this.focusedDatemaildate = null
      }
      const str: Date[] = r.dateReceived
      this.valuesrecieved = new Date(str.toString())
      this.profileForm.get('DateReceivedForm').setValue(this.valuesrecieved)
      this.focusedDateAccountformsecond = this.valuesrecieved
      this.labelDOB = r.clientDOB
      this.calculatedDob = this.calculateAge(r.clientDOB)
      this.ageAtTransaction = this.calculateAge(
        r.clientDOB,
        r.dateOfNewAccountForm,
      )
      setTimeout(() => (this.loader = false), 4000)
      setTimeout(() => (this.loaderType = false), 4000)
      //   this.ngxService.stopLoader('loader-77')
    })
  }
  getAccountAddonlistnoblotterId(
    clientId: number,
    repcode: number,
    gettransaction: number,
    getproducttype: number,
    repcodeId: number,
  ) {
    const param = {
      clientId: clientId,
      RepCodeId: repcodeId,
      transactionTypeId: gettransaction,
      productTypeId: getproducttype,
    }

    this.lk
      .GetAddonAdditionalAccountlistNoBlotterId(param)
      .subscribe((r: any) => {
        if (r.length == 0) {
          return
        }
        this.labelRepCode = r.repCode
        if (r.repCodeId) {
          this.getRepcodeId = Number(r.repCodeId)
          console.log('Set repCodeId from API (no blotterId):', this.getRepcodeId)
        } else {
          console.log('No repCodeId in API response (no blotterId). Current value:', this.getRepcodeId)
        }
        if (r.splitRepName) {
          this.labelSplitRepNameonoff = false
          this.labelSplitRepName = r.splitRepName
        }
        this.labelClientName = r.clientName
        this.labelProductType = r.producttypeDescription
        this.labelTransaction = r.transactionDescription
        this.profileForm.get('MailLog').setValue(r.mailLog)
        this.profileForm.get('MailTo').setValue(r.mailTo)
        this.profileForm.get('ccemails').setValue(r.ccemails)
        this.profileForm.get('StatusTypeID').setValue(r.getStatusId)
        this.profileForm
          .get('DocumentDescription')
          .setValue(r.documentDescription)
        this.profileForm.get('AlertRep').setValue(r.alertRep.toString())
        this.profileForm.get('AlertRepText').setValue(r.alertRepText)
        this.profileForm.get('WaveFee').setValue(r.waveFee.toString())
        this.profileForm.get('addressvalidated').setValue(r.addressvalidated.toString())
        this.labelStatus = r.getStatusDescription
        this.updateStatusList()
        this.showStatusHistoryButton = r.getStatusId !== -2
        const str2: Date[] = r.mailDate
        this.valuesmaildate = new Date(str2.toString())
        this.profileForm.get('MailDate').setValue(this.valuesmaildate)
        this.focusedDatemaildate = this.valuesmaildate

        const str: Date[] = r.dateOfNewAccountForm
        this.valuesrecieved = new Date(str.toString())
        this.profileForm.get('DateReceivedForm').setValue(this.valuesrecieved)
        this.focusedDateAccountformsecond = this.valuesrecieved
        this.labelDOB = r.clientDOB
      })
  }
  // EDIT ACCOUNTS FUNCTION BELOW //
  EditTransactionStartMethod(clientId: number) {
    const param = { ClientId: clientId, Edit: 1 }
    this.lk.getAccountInfofromviewAccount(param).subscribe((r: any) => {
      this.editaccountlist = r
      this.profileForm.get('RepId').setValue(r[0].repId)
      if (r[0].advisorClient != null) {
        this.profileForm
          .get('AdvisorClient')
          .setValue(r[0].advisorClient.toString())
      }
      this.profileForm.get('ClientTypeId').setValue(r[0].clientTypeId)
      if (r[0].taxId != null) {
        this.profileForm.get('TaxId').setValue(r[0].taxId)
      }
      if (r[0].taxIdmaskId != null) {
        this.profileForm.get('TaxIdmaskId').setValue(r[0].taxIdmaskId)
      }
      this.profileForm.get('AccountName').setValue(r[0].accountName)
      this.profileForm.get('FirstName').setValue(r[0].firstName)
      this.profileForm.get('MiddleName').setValue(r[0].middleName)
      this.profileForm.get('LastName').setValue(r[0].lastName)
      if (r[0].dob) {
        this.focusedDOBDate = this.valuesDOB
        const strdov: Date[] = r[0].dob
        this.valuesDOB = new Date(strdov.toString())
        this.profileForm.get('DOB').setValue(this.valuesDOB)
        this.focusedDOBDate = this.valuesDOB
      }
      this.profileForm.get('Address1').setValue(r[0].address1)
      this.profileForm.get('Address2').setValue(r[0].address2)
      this.profileForm.get('City').setValue(r[0].city)

      this.profileForm.get('State').setValue(r[0].state)
      this.profileForm.get('ZipCode').setValue(r[0].zipCode)
      this.profileForm.get('EmailAddress').setValue(r[0].emailAddress)
      this.profileForm.get('Mobile').setValue(toPhoneDigits(r[0].mobile))
      this.profileForm.get('AssociatedPerson').setValue(r[0].associatedPerson)
      this.profileForm.get('AssociatedAccount').setValue(r[0].associatedAccount)
      this.profileForm.get('AccountOpen').setValue(r[0].accountOpen)
      this.profileForm.get('CopyOfDl').setValue(r[0].copyOfDl)
      this.profileForm.get('NewAccountForm').setValue(r[0].newAccountForm)
      if (r[0].repSignature) {
        this.profileForm.get('RepSignature').setValue('true')
      } else {
        this.profileForm.get('RepSignature').setValue('false')
      }
      this.profileForm
        .get('SecondaryFirstName')
        .setValue(r[0].secondaryFirstName)
      if (r[0].dateOfNewAccountForm) {
        const str: Date[] = r[0].dateOfNewAccountForm
        this.values = new Date(str.toString())
        this.profileForm.get('DateOfNewAccountForm').setValue(this.values)
        this.focusedDateAccountform = this.values
      }
      if (r[0].maturityDate) {
        const strsecondarmature: Date[] = r[0].maturityDate
        this.valuessecondarymature = new Date(strsecondarmature.toString())
        this.profileForm
          .get('MaturityDate')
          .setValue(this.valuessecondarymature)
      }
      if (r[0].repSignature) {
        this.profileForm
          .get('cbCopyToSecondary')
          .setValue(r[0].cbCopyToSecondary)
      }
      this.profileForm
        .get('SecondaryMiddleName')
        .setValue(r[0].secondaryMiddleName)
      this.profileForm.get('SecondaryLastName').setValue(r[0].secondaryLastName)
      if (r[0].secondaryTaxId) {
        this.profileForm.get('SecondaryTaxID').setValue(r[0].secondaryTaxId)
      }
      if (r[0].secondaryDob) {
        const strsecondar: Date[] = r[0].secondaryDob
        this.valuessecondary = new Date(strsecondar.toString())
        this.profileForm.get('SecondaryDOB').setValue(this.valuessecondary)
      }
      this.profileForm.get('SecondaryAddress1').setValue(r[0].secondaryAddress1)
      this.profileForm.get('SecondaryAddress2').setValue(r[0].secondaryAddress2)
      this.profileForm.get('SecondaryCity').setValue(r[0].secondaryCity)
      this.profileForm.get('SecondaryState').setValue(r[0].secondaryState)
      this.profileForm.get('SecondaryZipCode').setValue(r[0].secondaryZipCode)
      if (r[0].annualIncFrom) {
        this.profileForm.get('AnnualIncFrom').setValue(r[0].annualIncFrom)
      }
      if (r[0].annualIncTo) {
        this.profileForm.get('AnnualIncTo').setValue(r[0].annualIncTo)
      }
      if (r[0].netWorthFrom) {
        this.profileForm.get('NetWorthFrom').setValue(Number(r[0].netWorthFrom))
      }
      if (r[0].netWorthTo) {
        this.profileForm.get('NetWorthTo').setValue(Number(r[0].netWorthTo))
      }
      if (r[0].liquidNWFrom) {
        this.profileForm.get('LiquidNWFrom').setValue(Number(r[0].liquidNWFrom))
      }
      if (r[0].liquidNWTo) {
        this.profileForm.get('LiquidNWTo').setValue(Number(r[0].liquidNWTo))
      }
      if (r[0].investmentProfileId) {
        this.profileForm
          .get('InvestmentProfileId')
          .setValue(r[0].investmentProfileId)
      }
      if (r[0].invObjectiveId) {
        this.profileForm.get('InvObjectiveId').setValue(r[0].invObjectiveId)
      }
      if (r[0].liquidityNeedsId) {
        this.profileForm.get('LiquidityNeedsId').setValue(r[0].liquidityNeedsId)
      }
      //  this.profileForm.get('InvestmentTimeHorizonId').setValue(3);
      if (r[0].investmentTimeHorizonId) {
        this.profileForm
          .get('InvestmentTimeHorizonId')
          .setValue(r[0].investmentTimeHorizonId)
      }
      if (r[0].equitiesExp) {
        this.profileForm.get('EquitiesExp').setValue(r[0].equitiesExp)
      }
      if (r[0].optionsExp) {
        this.profileForm.get('OptionsExp').setValue(r[0].optionsExp)
      }
      if (r[0].fixedIncExp) {
        this.profileForm.get('FixedIncExp').setValue(r[0].fixedIncExp)
      }
      if (r[0].etfexp) {
        this.profileForm.get('Etfexp').setValue(r[0].etfexp)
      }
      if (r[0].uitexp) {
        this.profileForm.get('Uitexp').setValue(r[0].uitexp)
      }
      if (r[0].realEstateExp) {
        this.profileForm.get('RealEstateExp').setValue(r[0].realEstateExp)
      }
      if (r[0].insExp) {
        this.profileForm.get('InsExp').setValue(r[0].insExp)
      }
      if (r[0].vaexp) {
        this.profileForm.get('Vaexp').setValue(r[0].vaexp)
      }
      if (r[0].fixedAnnExp) {
        this.profileForm.get('FixedAnnExp').setValue(r[0].fixedAnnExp)
      }
      if (r[0].precMetExp) {
        this.profileForm.get('PrecMetExp').setValue(r[0].precMetExp)
      }
      if (r[0].mutFundsExp) {
        this.profileForm.get('MutFundsExp').setValue(r[0].mutFundsExp)
      }
      if (r[0].commExp) {
        this.profileForm.get('CommExp').setValue(r[0].commExp)
      }
      if (r[0].otherExp) {
        this.profileForm.get('OtherExp').setValue(r[0].otherExp)
      }
      if (r[0].otherExpDesc) {
        this.profileForm.get('OtherExpDesc').setValue(r[0].otherExpDesc)
      }
      if (r[0].comment) {
        this.profileForm.get('Comment').setValue(r[0].comment)
      }
      // this.setSelectedStateByText(r[0].state)
      this.OnEditshowVerbiagerules()
    })
  }
  OnEditshowVerbiagerules() {
    const drop = this.profileForm.value.ClientTypeId
    if (this.profileForm.value.TaxIdmaskId === null) {
      this.profileForm.get('TaxIdmaskId').setValue(1)
      if (drop === 7 || drop === 8) {
        this.mask = '##-#######'
        this.profileForm.get('TaxIdmaskId').setValue(2)
      } else {
        this.mask = '###-##-####'
        this.profileForm.get('TaxIdmaskId').setValue(1)
      }
    }
    if (drop == 34) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A - INDV 401K</span>'
    }
    if (drop == 1) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A. - INDV</span>'

      return
    }
    if (drop == 2) {
      this.HeaderInfo = 'Primary Client Information'
      this.secondaryheader =
        'Copy Primary Client Address to Secondary Client Address'
      this.secondarymainheader = 'Secondary Client Information'
      this.Tr1 = true
      this.Msecondary = true
      this.secondaryForm = true
      this.displaysecondaryck = false
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN L. & JANE P. - JOINT</span>'

      return
    }
    if (drop == 3) {
      this.HeaderInfo = 'Non-Individual Client Information'
      this.Tr1 = false
      this.mask = '###-##-####'
      this.profileForm.get('TaxIdmaskId').setValue(1)
      this.displayInfo = true
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">AMERICAN COMPANY INC - CORP</span>'
      return
    }
    if (drop == 4) {
      this.HeaderInfo = 'Account Information'
      this.secondaryheader = 'Custodian Information'
      return
    }
    if (drop == 5) {
      this.HeaderInfo = 'Minor Information'
      this.secondaryheader = 'Copy over Minor infomation to Cusodian'
      this.displaysecondaryck = false
      this.secondarymainheader = 'Custodian Information'
      this.Tr1 = true
      this.secondaryForm = true
      this.Msecondary = true
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A CF JANE DOE - UTMA</span>'

      return
    }
    if (drop == 6) {
      this.secondarymainheader = 'Beneficiary Information'
      this.secondaryheader = 'Copy Account Address to Beneficiary Address'
      this.secondaryForm = true
      this.displaysecondaryck = true
      this.HeaderInfo = 'Account Information'
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A FBO JANE DOE - 529</span>'
      this.cdr.detectChanges()
      return
    }
    if (drop == 7) {
      this.secondaryheader = 'Copy Account Address to Employee Address'
      this.displaysecondaryck = true
      this.displayInfo = true
      this.FirstNamecompany = 'Company Name:'
      this.HeaderInfo = 'Employer Information'
      this.secondarymainheader = 'Employee Information'
      this.Tr1 = true
      this.secondaryForm = true
      this.profileForm.get('LastName').clearValidators()
      this.profileForm.get('LastName').updateValueAndValidity()
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">AMERICAN & ASSOCIATES 401K PLAN - 401K</span>'
      return
    }
    if (drop == 8) {
      this.displaysecondaryck = true
      this.HeaderInfo = 'Trust information'
      this.secondaryheader = ''
      this.secondarymainheader = 'Trustee information'
      this.Tr1 = true
      this.displaysecondaryck = false
      this.secondaryForm = true
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">JOHN DOE TRUST DTD 1/14/98, JOHN DOE TTEE - TRUST</span>'
      return
    }
    if (drop == 22) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings"> </span>'

      return
    }
    if (drop == 23) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A. - ROTH</span>'

      return
    }
    if (drop == 24) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">  </span>'

      return
    }
    if (drop == 25) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A. - SEP</span>'
      return
    }
    if (drop == 33) {
      this.displaysecondaryck = true
      this.HeaderInfo = 'Account Information'
      this.secondaryheader = ''
      this.secondarymainheader = 'Beneficiary Information'
      this.Tr1 = true
      this.secondaryForm = true
      this.displaysecondaryck = false
      this.secondaryheader = 'Beneficiary Information'
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A CF JANE DOE - ESA</span>'
      return
    }
    if (drop == 34) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A - INDV 401K</span>'
      return
    }
    if (drop == 34) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings"> </span>'

      return
    }
    if (drop == 46) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN A - 403B</span>'
      return
    }
    if (drop == 52) {
      this.displaytext =
        '<b class="textdisplay">Format:</b> <span class="textsettings">DOE, JOHN - BEN ROTH IRA</span>'
      return
    }
  }
  onFocus0(dp0: DatePickerComponent) {
    if (!dp0.isOpen) {
      //dp0.toggle(true)
    }
  }
  onFocus1(dp1: DatePickerComponent) {
    this.dateFormActive = true
    this.dateFormPicker = dp1
    if (!dp1.isOpen) {
      dp1.toggle(true)
    }
  }
  onDateFormBlur() {
    this.dateFormActive = false
  }
  // Listens on document so it still fires when focus is inside the calendar popup (rendered in body).
  @HostListener('document:keydown.tab', ['$event'])
  onDateOfAccountFormTab(event: KeyboardEvent) {
    // After Date of Account Form, send focus back up to the Investment Information fields.
    if (!this.dateFormActive || event.shiftKey) {
      return
    }
    event.preventDefault()
    event.stopPropagation()
    this.dateFormActive = false
    this.dateFormPicker?.toggle(false)
    // Defer so the datepicker popup fully closes before we move/scroll focus.
    setTimeout(() => {
      this.annualIncFrom?.focus()
      const target = document.querySelector('[formcontrolname="AnnualIncFrom"]') as HTMLElement | null
      target?.scrollIntoView({ behavior: 'smooth', block: 'center' })
    })
  }
  onFocus12(dp2: DatePickerComponent) {
    if (!dp2.isOpen) {
      dp2.toggle(true)
    }
  }
  onFocus3(dp3: DatePickerComponent) {
    if (!dp3.isOpen) {
      dp3.toggle(true)
    }
  }
  pushCopyData() {
    this.isSameAddressControl.valueChanges
      .pipe(
        distinctUntilChanged(),
        switchMap((isSameAddress) => {
          if (isSameAddress) {
            return this.profileForm.get('FirstName').valueChanges.pipe(
              // at the beginning fill the form with the current values
              startWith(this.profileForm.get('FirstName').value),
              tap((value) =>
                // every time the sending address changes, update the billing address
                this.profileForm.get('SecondaryFirstName').setValue(value),
              ),
            )
          } else {
            this.profileForm.get('SecondaryFirstName').reset()

            return EMPTY
          }
        }),
        // don't forget to unsubscribe when component's destroyed
      )
      .subscribe()
    this.isSameAddressControl.valueChanges
      .pipe(
        distinctUntilChanged(),
        switchMap((isSameAddress) => {
          if (isSameAddress) {
            return this.profileForm.get('LastName').valueChanges.pipe(
              // at the beginning fill the form with the current values
              startWith(this.profileForm.get('LastName').value),
              tap((value) =>
                // every time the sending address changes, update the billing address
                this.profileForm.get('SecondaryLastName').setValue(value),
              ),
            )
          } else {
            this.profileForm.get('SecondaryLastName').reset()

            return EMPTY
          }
        }),
        // don't forget to unsubscribe when component's destroyed
      )
      .subscribe()
    this.isSameAddressControl.valueChanges
      .pipe(
        distinctUntilChanged(),
        switchMap((isSameAddress) => {
          if (isSameAddress) {
            return this.profileForm.get('MiddleName').valueChanges.pipe(
              // at the beginning fill the form with the current values
              startWith(this.profileForm.get('MiddleName').value),
              tap((value) =>
                // every time the sending address changes, update the billing address
                this.profileForm.get('SecondaryMiddleName').setValue(value),
              ),
            )
          } else {
            this.profileForm.get('SecondaryMiddleName').reset()

            return EMPTY
          }
        }),
        // don't forget to unsubscribe when component's destroyed
      )
      .subscribe()
    this.isSameAddressControl.valueChanges
      .pipe(
        distinctUntilChanged(),
        switchMap((isSameAddress) => {
          if (isSameAddress) {
            return this.profileForm.get('focusedDOBDate').valueChanges.pipe(
              // at the beginning fill the form with the current values
              startWith(this.profileForm.get('focusedDOBDate').value),
              tap((value) =>
                // every time the sending address changes, update the billing address
                this.profileForm.get('SecondaryDOB').setValue(value),
              ),
            )
          } else {
            this.profileForm.get('SecondaryDOB').reset()

            return EMPTY
          }
        }),
      )
      .subscribe()
    this.isSameAddressControl.valueChanges
      .pipe(
        distinctUntilChanged(),
        switchMap((isSameAddress) => {
          if (isSameAddress) {
            return this.profileForm.get('Address1').valueChanges.pipe(
              // at the beginning fill the form with the current values
              startWith(this.profileForm.get('Address1').value),
              tap((value) =>
                // every time the sending address changes, update the billing address
                this.profileForm.get('SecondaryAddress1').setValue(value),
              ),
            )
          } else {
            this.profileForm.get('SecondaryAddress1').reset()

            return EMPTY
          }
        }),
      )
      .subscribe()
    this.isSameAddressControl.valueChanges
      .pipe(
        distinctUntilChanged(),
        switchMap((isSameAddress) => {
          if (isSameAddress) {
            return this.profileForm.get('Address2').valueChanges.pipe(
              // at the beginning fill the form with the current values
              startWith(this.profileForm.get('Address2').value),
              tap((value) =>
                // every time the sending address changes, update the billing address
                this.profileForm.get('SecondaryAddress2').setValue(value),
              ),
            )
          } else {
            this.profileForm.get('SecondaryAddress2').reset()

            return EMPTY
          }
        }),
      )
      .subscribe()
    this.isSameAddressControl.valueChanges
      .pipe(
        distinctUntilChanged(),
        switchMap((isSameAddress) => {
          if (isSameAddress) {
            return this.profileForm.get('TaxId').valueChanges.pipe(
              // at the beginning fill the form with the current values
              startWith(this.profileForm.get('TaxId').value),
              tap((value) =>
                // every time the sending address changes, update the billing address
                this.profileForm.get('SecondaryTaxID').setValue(value),
              ),
            )
          } else {
            this.profileForm.get('SecondaryTaxID').reset()

            return EMPTY
          }
        }),
      )
      .subscribe()
    this.isSameAddressControl.valueChanges
      .pipe(
        distinctUntilChanged(),
        switchMap((isSameAddress) => {
          if (isSameAddress) {
            return this.profileForm.get('City').valueChanges.pipe(
              // at the beginning fill the form with the current values
              startWith(this.profileForm.get('City').value),
              tap((value) =>
                // every time the sending address changes, update the billing address
                this.profileForm.get('SecondaryCity').setValue(value),
              ),
            )
          } else {
            this.profileForm.get('SecondaryCity').reset()

            return EMPTY
          }
        }),
      )
      .subscribe()
    this.isSameAddressControl.valueChanges
      .pipe(
        distinctUntilChanged(),
        switchMap((isSameAddress) => {
          if (isSameAddress) {
            return this.profileForm.get('State').valueChanges.pipe(
              // at the beginning fill the form with the current values
              startWith(this.profileForm.get('State').value),
              tap((value) =>
                // every time the sending address changes, update the billing address
                this.profileForm.get('SecondaryState').setValue(value),
              ),
            )
          } else {
            this.profileForm.get('SecondaryState').reset()

            return EMPTY
          }
        }),
      )
      .subscribe()
    this.isSameAddressControl.valueChanges
      .pipe(
        distinctUntilChanged(),
        switchMap((isSameAddress) => {
          if (isSameAddress) {
            return this.profileForm.get('ZipCode').valueChanges.pipe(
              // at the beginning fill the form with the current values
              startWith(this.profileForm.get('ZipCode').value),
              tap((value) =>
                // every time the sending address changes, update the billing address
                this.profileForm.get('SecondaryZipCode').setValue(value),
              ),
            )
          } else {
            this.profileForm.get('SecondaryZipCode').reset()

            return EMPTY
          }
        }),
      )
      .subscribe()
  }

  public openStatusHistory(blotterId: number) {
    this.showStatusHistoryDialog = true
    if (blotterId) {
      this.middleService
        .GetBlotterHistory(blotterId)
        .subscribe((relist: any) => {
          this.stathistorylist = relist
          this.cdr.detectChanges()
        })
    }
  }

  public closeDialog() {
    this.showStatusHistoryDialog = false
  }

  // Calculates difference between two dates in years.
  // If no second date is provided, the current date is used.
  calculateAge(
    fromDate: string,
    toDate: string = new Date().toString(),
  ): string {
    const from = new Date(fromDate)
    const to = new Date(toDate)

    let yearsDifference = to.getFullYear() - from.getFullYear()

    if (
      to.getMonth() < from.getMonth() ||
      (to.getMonth() === from.getMonth() && to.getDate() < from.getDate())
    ) {
      yearsDifference--
    }

    return yearsDifference.toString()
  }

  // Updates the status list to include 'Approved' option if current status is 'Approved'
  private updateStatusList() {
    const baseList: Array<Item> = [
      { text: 'Rep Processing Paperwork', value: -2 },
      { text: 'Processing Paperwork', value: 0 },
      { text: 'Submitted for Review', value: 1 },
    ]

    if (this.labelStatus === 'Approved') {
      this.SeletedupdatedList = [{ text: 'Approved', value: 11 }]
    } else {
      this.SeletedupdatedList = baseList
    }
    this.captureApprovedAlertBaseline()
  }

  // Called from updateStatusList() because that already runs on both load paths,
  // right after labelStatus and AlertRep are populated - so this reads the alert
  // as it came off the transaction rather than after any user edit.
  private captureApprovedAlertBaseline() {
    this.approvedAlertWasOn = this.isFlagTrue(
      this.profileForm.get('AlertRep')?.value,
    )
  }

  // AlertRep arrives as the string 'true'/'false' from the API while the radio
  // options carry booleans, so both shapes have to be treated the same.
  private isFlagTrue(value: any): boolean {
    return value === true || String(value).toLowerCase() === 'true'
  }

  // An Approved transaction is read-only, with one exception: an alert that
  // arrived switched on may be turned off and saved.
  private canClearApprovedAlert(): boolean {
    if (!this.approvedAlertWasOn) {
      return false
    }
    const ctrl = this.profileForm.get('AlertRep')
    if (!ctrl || ctrl.disabled) {
      return false
    }
    // Only unlock once the user has actually switched the alert off.
    return ctrl.dirty && !this.isFlagTrue(ctrl.value)
  }

  // Approved cannot be deleted. Admins stay exempt, matching the Update rule and
  // canAlwaysDelete on the Transaction screen. No alert carve-out here: clearing
  // an alert is an update, not a delete.
  get isDeleteDisabled(): boolean {
    return this.labelStatus === 'Approved' && !this.isAdmin
  }

  // Determines if the update button should be disabled
  get isUpdateDisabled(): boolean {
    if (this.labelStatus !== 'Approved' || this.isAdmin) {
      return false
    }
    // Previously this returned false (enabled) whenever AlertRep was already
    // 'false', which left every Approved transaction without an alert fully
    // editable. Now the only way through is actively clearing an alert.
    return !this.canClearApprovedAlert()
  }
}
